<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-2">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Working Experience, Candidate Name"
              aria-label="Working Experience"
              aria-describedby="basic-addon2"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getTalents($event)">Search</button>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-lg-4 mb-2">
          <select class="form-control" @change="getTalents($event)">
            <option value>-- Select Specialization --</option>
            <template v-for="(data, key) in specializationsList">
              <option v-bind:key="key" v-bind:value="data.specialization_id">{{ data.name }}</option>
            </template>
          </select>
        </div>-->
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <talents-table :search="this.search_text"></talents-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "./../event-bus";
import TalentsTable from "./Tables/TalentsTable";

export default {
  name: "tables",
  components: {
    TalentsTable
  },
  data() {
    return {
      search_text: ""
    };
  },
  mounted() {
    this.getSpecializations();
  },
  computed: {
    pageNumber() {
      return parseInt(this.$route.query.page);
    },

    specializationsList() {
      return this.$store.getters.specializationsList;
    }
  },
  methods: {
    getTalents: function(event) {
      var specializationId = event.target.value;
      if (specializationId == "") specializationId = 0;

      EventBus.$emit('searchTalents');      
    },

    getSpecializations() {
      this.$store.dispatch("fetchSpecializationList").then(response => {
        this.$store.dispatch("updateState", {
          key: "specializationsList",
          value: response.data
        });
      });
    }
  }
};
</script>
<style>
.input-group-append .btn {
  z-index: auto;
}
</style>
